export const API = {
  USER_LOGI_IN: "v1/Auth/Login",
  USER_FORGOT_PASSWORD: "v1/Auth/ForgotPassword",
  USER_RESET_PASSWORD: "v1/Auth/UpdatePassword",
  GET_DIRECTORY_META_DATA_LIST: "v1/Directory/GetDirectoryMetaDataList",
  GET_COUNTRY_LIST: 'v1/Country/GetCountrySelectList',
  GET_STATE_LIST: 'v1/StateProvince/GetStateProvinceSelectListByCountryId',
  GET_STORES_LIST: 'v1/Store/GetStoresSelectList',
  GET_MATERIAL_TYPE_LIST: 'v1/MaterialType/GetMaterialTypeSelectList',
  PULL_PRODUCTS: 'v1/PullData/PullProducts',
  NOTIFICATION_MARK_AS_READ: 'v1/Notification/NotificationMarkAsRead',
  GET_NOTIFICATIONS_LIST: 'v1/Notification/GetNotificationsList',
  GET_NOTIFICATIONS_UNREAD_COUNT: 'v1/Notification/GetNotificationsUnreadCount',
  LOGOUT_USER: 'v1/Auth/Logout'

}
